import React from 'react';
import { NavLink } from "react-router-dom";
import Barchart from '../components/charts/Barchart';
import LineChart from '../components/charts/Linechart';
import Piechart from '../components/charts/Piechart';
import Sidebar from './Sidebar';




export default function Dashboard(props) {

  const welcome_msg = [
    {
      name : "John Doe",
      quote : "“Health is not valued until sickness comes.” ",
      button: "Learn More",
      button_url: "/"
    }
  ]

  const reminder =[
    {
    time : "48 Min",
    heading : "Streching",
    icon : "fitness_center"
    },
    {
    time : "24 Min",
    heading : "Mind Training",
    icon : "psychology"
    },
    {
    time : "8 Hrs",
    heading : "Sleep",
    icon : "bedtime"
    },

]

  return (
    <div>
      <Sidebar/>
      <div className="tab_content_outer dashboard_outer">
        <div className="container">
          <h2 className='page_title'>{props.title}</h2>
          <div className='content'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='cards'>
                  <div className='welcome'>
                   {
                      welcome_msg.map((item, index) => (
                      <div className='welcome_content'>
                        <h4>Hello <span>{item.name}</span></h4>
                        <p>{item.quote}</p>
                        <button><NavLink to={item.button_url}></NavLink>{item.button}</button>
                      </div>                                   
                      ))}  
                  </div>
                  
                </div>

                <div className='cards'>
                  <Barchart/>
                </div>
              <div className='cards'>
                <h3 className='reminder_heading'>Reminder</h3>
                <div className='reminder'>
              {
                reminder.map((item, index) => (
                <div className='reminder_content'>
                  <i className="list_icon material-icons">{item.icon}</i>
                  <h4>{item.time} <span>{item.heading}</span></h4>
                </div>                       
              ))}  
              </div>  
              </div>
              </div>
              <div className='col-md-6'>
                <div className='cards'>
                  <LineChart/>
                </div>

                <div className='cards'>
                  <h3 className='piechart_heaeding'>Reports</h3>
                  <Piechart/>
                </div>
                

              </div>

            </div>

          </div>
 
        </div>
      </div>
    </div>
  )
}
